import { AbstractLocaleMessageObject } from "@/i18n/AbstractLocaleMessageObject"

import { ISystemError } from "%%/labels/interfaces"

export class SystemErrorEn extends AbstractLocaleMessageObject implements ISystemError {
  readonly toLogin = "To Login Screen"
}
